"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
exports.Currency = {
    USD: 'USD',
    JPY: 'JPY',
};
